import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "show-holder" }
const _hoisted_2 = { class: "product-quantity" }
const _hoisted_3 = ["data-quantity"]
const _hoisted_4 = {
  key: 1,
  class: "product-add-to-cart"
}
const _hoisted_5 = ["data-quantity"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!

  return (!_ctx.isFinished)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{'is-active' : _ctx.isVisible || _ctx.focus }, "product-add-to-cart"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("button", {
            class: _normalizeClass([{'is-disabled': _ctx.product.quantity === 0}, "product-btn product-decrease ion-activatable ripple-parent"]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setQuantity($event, _ctx.product, _ctx.productQuantity - 1), _ctx.inputValue = _ctx.productQuantity))
          }, [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([{'is-visible' : _ctx.product.quantity <= 1}, "icon bin"]),
              fill: "none",
              viewBox: "0 0 14 18",
              xmlns: "http://www.w3.org/2000/svg"
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("path", {
                d: "M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1Z",
                fill: "#D98240"
              }, null, -1)
            ]))], 2)),
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass([{'is-visible' : _ctx.product.quantity > 1 }, "icon min"]),
              fill: "none",
              viewBox: "0 0 14 2",
              xmlns: "http://www.w3.org/2000/svg"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("path", {
                d: "M14 2H8H6H0V0H6H8H14V2Z",
                fill: "#D98240"
              }, null, -1)
            ]))], 2)),
            _createVNode(_component_ion_ripple_effect)
          ], 2),
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValue) = $event)),
              min: "0",
              type: "number",
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focus = false)),
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.focus = true)),
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setQuantityByCustomInput($event, _ctx.product, _ctx.inputValue)))
            }, null, 544), [
              [_vModelText, _ctx.inputValue]
            ])
          ])
        ]),
        _createElementVNode("button", {
          class: _normalizeClass([_ctx.productIncrease, "product-btn product-increase ion-activatable ripple-parent"]),
          "data-quantity": _ctx.productQuantity,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setQuantity($event, _ctx.product, _ctx.productQuantity + 1), _ctx.inputValue = _ctx.productQuantity))
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("svg", {
            class: "plus",
            fill: "none",
            viewBox: "0 0 14 14",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z",
              fill: "white"
            })
          ], -1)),
          _createVNode(_component_ion_ripple_effect)
        ], 10, _hoisted_3)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", {
          "data-quantity": _ctx.productQuantity,
          class: "product-quantity inactive-count"
        }, null, 8, _hoisted_5)
      ]))
}